import * as React from "react";
import styled from "../../../styled/index";
import { CS } from "../../../styles/index";

interface IconCircleProps extends React.HTMLAttributes<HTMLDivElement> {
  size: number;
  iconSizeModifier?: number;
  icon?: React.ReactNode;
  background?: string;
}

const Icon = styled("div")<IconCircleProps>`
  ${CS.flex.center};
  border-radius: 50%;
  // @ts-ignore
  background: ${({background, theme}) => theme.status_colors[background] || background || theme.colors.primary};
  color: white;
  width: ${({size}) => size}px;
  height: ${({size}) => size}px;
  font-size: ${({size, iconSizeModifier}) => size - (iconSizeModifier || 18)}px;
`;

export const IconCircle = (props: IconCircleProps) => (
  <Icon {...props}>
    {!!props.icon && props.icon}
    {!props.icon && props.children}
  </Icon>
);
